/*
This file is meant to apply any overrides, at the shop level, to the functions/features of the Recurate app
*/

/* Uncomment this to disable TurboLinks for this shop
(function() {
    let allAnchors = document.getElementsByTagName("a");
    for(var i=0,l=allAnchors.length; i<l; i++) {
        allAnchors[i].setAttribute(“data-turbolinks”, "false");
    }
})();*/

(function() {
    const usedBtn = document.getElementById("recurate-sell-used-btn");
    if(usedBtn) {
        usedBtn.innerHTML = "List Now";
    }
    
    const saveBtn = document.getElementById("recurate-save-btn");
    if(saveBtn) {
        saveBtn.innerHTML = "Save To Draft";
    }

    const instructionsText = document.querySelector("form#new_submission h3.recurate-h3 + p.recurate-body");
    if(instructionsText) {
        instructionsText.innerHTML = "Please fill out the complete form below. We will review your listing and let you know if it is approved.";
    }

    const slfCheck = document.getElementById("confirmation_box");
    const slfCheckDislaimer = document.querySelector("#confirmation_box + label");
    if(slfCheck) {
        slfCheck.checked = true;
        slfCheck.style.display = "none";
        if(slfCheckDislaimer) {
            slfCheckDislaimer.innerHTML = "By clicking the LIST NOW or SAVE button below, you (a) agree that all content and information you submit is complete and accurate, and (b) acknowledge that you have read and agree to the <a class=\"mk-link-small\" href=\"/pages/michael-kors-pre-loved-resale-program-terms\" target=\"_blank\">Michael Kors Pre-Loved Program Terms</a>, the Website <a href=\"https://www.michaelkors.com/info/terms-conditions/s11400082\" target=\"_blank\">Terms & Conditions</a> and <a href=\"https://www.michaelkors.com/info/privacy-policy/s11400079\" target=\"_blank\">Privacy Policy</a>.";
        }
    }    

    const imagesText = document.querySelector(".new-images #image-popup + .recurate-body");
    if(imagesText) {
        imagesText.innerHTML = "Upload a least 3 well-lit photos of your item on a flat, solid background.";
    }

    const noPurchasesCheck = document.querySelector("#recurate-submissions-index-title + #recurate-submissions-index-subtitle + .recurate-line-1 + #seller-line-items .card-body h3");
    if(noPurchasesCheck) {
        if(noPurchasesCheck.innerHTML.trim() == "We couldn’t find any past online purchases") {
            noPurchasesCheck.innerHTML = "We couldn't find any past eligible purchases";
        }
    }

    const creditInfo = document.querySelector(".p-credit.recurate-body");
    if(creditInfo) {        
        const creditAppend = document.createElement("p");
        creditAppend.innerHTML = "E-gift cards will be sent via email to the email address linked to your KORSVIP account from our service provider, Loop Commerce (\"Gift Now\"), acting on our behalf.";
        creditInfo.appendChild(creditAppend);
    }

    const submissionCondition = document.getElementById("submission_condition");
    if(submissionCondition) {
        submissionCondition.setAttribute("title","Product Condition");
        submissionCondition.setAttribute("aria-label","Product Condition");
    }

    const countryCode = document.getElementById("submission_seller_address_attributes_country_code");
    if(countryCode) {
        countryCode.setAttribute("title","Country");
        countryCode.setAttribute("aria-label","Country");
    }

    const pricingDivs = document.querySelectorAll(".recurate-product-info-div > .recurate-h5 + .recurate-body + .recurate-body");
    if(pricingDivs) {
        for (i = 0; i < pricingDivs.length; ++i) {
            let thisDiv = pricingDivs[i];
            if(thisDiv.innerHTML.indexOf("Original price") >= 0) {
                let thisDivContent = thisDiv.innerHTML;
                thisDiv.innerHTML = thisDivContent.replace("Original price","Price paid");
            }
        }
    }
})();

window.addEventListener("load", (event) => {
  console.log("page is fully loaded");

  if (window.location.href.indexOf('submissions/new') > -1) {
    //on new submission page
    console.log('On new submissions page');
    document.getElementById('story-field').required = true;

  }

});

